// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrderPopupStatus_container__1hbJX .OrderPopupStatus_main-message__lqpiC {
  font-size: 20px;
  padding-top: 30px;
}
.OrderPopupStatus_container__1hbJX .OrderPopupStatus_sub-message__piO44 {
  font-size: 14px;
}
.OrderPopupStatus_container__1hbJX .OrderPopupStatus_sub-message-error__ughjI {
  font-size: 14px;
  color: #e15b5c;
}
.OrderPopupStatus_container__1hbJX .OrderPopupStatus_sub-message-green__vBaoL {
  font-size: 14px;
  color: #008863;
}
.OrderPopupStatus_container__1hbJX .OrderPopupStatus_buttons-wrapper__XLoCc {
  display: flex;
  padding-top: 30px;
  margin-bottom: -50px;
  min-width: 420px;
}
.OrderPopupStatus_container__1hbJX Button {
  margin: auto;
}
.OrderPopupStatus_container__1hbJX img {
  margin-top: -25px;
}`, "",{"version":3,"sources":["webpack://./src/views/Payment/OrderPopupStatus/OrderPopupStatus.module.scss","webpack://./src/styles/_typography.scss"],"names":[],"mappings":"AAIE;EACE,eAAA;EACA,iBAAA;AAHJ;AAKE;EACE,eCRK;ADKT;AAKE;EACE,eCXK;EDYL,cAAA;AAHJ;AAKE;EACE,eCfK;EDgBL,cAAA;AAHJ;AAKE;EACE,aAAA;EACA,iBAAA;EACA,oBAAA;EACA,gBAAA;AAHJ;AAKE;EACE,YAAA;AAHJ;AAKE;EACE,iBAAA;AAHJ","sourcesContent":["@use \"styles/colors\";\n@use \"styles/typography\";\n\n.container {\n  .main-message {\n    font-size: 20px;\n    padding-top: 30px;\n  }\n  .sub-message {\n    font-size: typography.$body-m;\n  }\n  .sub-message-error {\n    font-size: typography.$body-m;\n    color: #e15b5c;\n  }\n  .sub-message-green {\n    font-size: typography.$body-m;\n    color: #008863;\n  }\n  .buttons-wrapper {\n    display: flex;\n    padding-top: 30px;\n    margin-bottom: -50px;\n    min-width: 420px;\n  }\n  Button {\n    margin: auto;\n  }\n  img {\n    margin-top: -25px;\n  }\n}\n","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `OrderPopupStatus_container__1hbJX`,
	"main-message": `OrderPopupStatus_main-message__lqpiC`,
	"sub-message": `OrderPopupStatus_sub-message__piO44`,
	"sub-message-error": `OrderPopupStatus_sub-message-error__ughjI`,
	"sub-message-green": `OrderPopupStatus_sub-message-green__vBaoL`,
	"buttons-wrapper": `OrderPopupStatus_buttons-wrapper__XLoCc`
};
export default ___CSS_LOADER_EXPORT___;
